/* HMRV facets (2026-10-04)
 * - Any filter group with > 8 values shows the first 8 (+ any checked values) and a "Show all (N)" / "Show less" button.
 * - Heater model (and any list group with > 15 values) gets a live search box.
 * - Collapsed defaults are handled server-side (section data "collapse_all" + data-filter-open on Availability).
 * Event delegation on document + MutationObserver, so it keeps working when the theme moves the sidebar
 * into the mobile filter drawer or re-renders/replaces the facets HTML.
 */
(function () {
  'use strict';
  if (window.__hmrvFacetsInit) return;
  window.__hmrvFacetsInit = true;
  document.documentElement.classList.add('hmrv-facets-js');

  var GROUP = '[data-hmrv-facet-group]';
  var ITEM = '[data-hmrv-facet-item]';

  function norm(s) { return (s || '').toLowerCase().replace(/\s+/g, ' ').trim(); }
  function squash(s) { return (s || '').toLowerCase().replace(/[^a-z0-9]+/g, ''); }

  function itemText(li) {
    if (li.__hmrvText == null) {
      var t = li.getAttribute('data-hmrv-text');
      if (!t) {
        var el = li.querySelector('.collection-filters__filter-list-item-text') || li;
        t = el.textContent.replace(/\(\d+\)\s*$/, '');
      }
      li.__hmrvText = norm(t);
      li.__hmrvSquash = squash(t);
    }
    return li.__hmrvText;
  }

  function isActive(li) {
    return li.classList.contains('collection-filters__filter-list-item--active') ||
      !!li.querySelector('.collection-filters__filter-link[data-filter-active]');
  }

  function setExpanded(group, expanded) {
    var btn = group.querySelector('[data-hmrv-facet-toggle]');
    group.classList.toggle('hmrv-expanded', !!expanded);
    if (!btn) return;
    var n = btn.getAttribute('data-count') || group.querySelectorAll(ITEM).length;
    btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    btn.textContent = expanded ? 'Show less' : 'Show all (' + n + ')';
  }

  function applySearch(group, raw) {
    var q = norm(raw);
    var qs = squash(raw);
    var items = group.querySelectorAll(ITEM);
    var matches = 0;
    for (var i = 0; i < items.length; i++) {
      var li = items[i];
      var t = itemText(li);
      var ok = !q || t.indexOf(q) !== -1 || (qs && li.__hmrvSquash.indexOf(qs) !== -1);
      if (ok) { li.removeAttribute('data-hmrv-nomatch'); matches++; }
      else li.setAttribute('data-hmrv-nomatch', '');
    }
    group.classList.toggle('hmrv-searching', !!q);
    var none = group.querySelector('[data-hmrv-facet-nomatch]');
    if (none) none.hidden = !(q && matches === 0);
    var live = group.querySelector('[data-hmrv-facet-live]');
    if (live) live.textContent = q ? (matches ? matches + (matches === 1 ? ' match' : ' matches') : 'No matches') : '';
  }

  function setup(group) {
    if (group.__hmrvReady) return;
    group.__hmrvReady = true;
    var limit = parseInt(group.getAttribute('data-hmrv-limit'), 10) || 8;
    var items = group.querySelectorAll(ITEM);
    for (var i = 0; i < items.length; i++) {
      if (i >= limit && !isActive(items[i])) items[i].setAttribute('data-hmrv-overflow', '');
      else items[i].removeAttribute('data-hmrv-overflow');
    }
    setExpanded(group, false);
    var input = group.querySelector('[data-hmrv-facet-search]');
    // Browsers can restore a typed value on back/forward navigation
    if (input && input.value) applySearch(group, input.value);
    group.classList.add('hmrv-ready');
  }

  function scan(root) {
    if (!root || root.nodeType !== 1) return;
    if (root.matches && root.matches(GROUP)) setup(root);
    var gs = root.querySelectorAll ? root.querySelectorAll(GROUP) : [];
    for (var i = 0; i < gs.length; i++) setup(gs[i]);
  }

  // Delegated events: survive node moves (mobile drawer) and HTML replacement
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-hmrv-facet-toggle]');
    if (!btn) return;
    var group = btn.closest(GROUP);
    if (!group) return;
    e.preventDefault();
    var expand = btn.getAttribute('aria-expanded') !== 'true';
    setExpanded(group, expand);
    if (!expand && btn.scrollIntoView) {
      try { btn.scrollIntoView({ block: 'nearest' }); } catch (err) { /* noop */ }
    }
  });

  document.addEventListener('input', function (e) {
    var input = e.target;
    if (!input.matches || !input.matches('[data-hmrv-facet-search]')) return;
    var group = input.closest(GROUP);
    if (group) applySearch(group, input.value);
  });

  // 'search' fires when the native clear (x) is used in some browsers
  document.addEventListener('search', function (e) {
    var input = e.target;
    if (!input.matches || !input.matches('[data-hmrv-facet-search]')) return;
    var group = input.closest(GROUP);
    if (group) applySearch(group, input.value);
  }, true);

  document.addEventListener('keydown', function (e) {
    var input = e.target;
    if (!input.matches || !input.matches('[data-hmrv-facet-search]')) return;
    if (e.key === 'Enter') { e.preventDefault(); return; }
    if (e.key === 'Escape' && input.value) {
      // First Escape clears the search instead of closing the mobile drawer
      e.preventDefault();
      e.stopPropagation();
      input.value = '';
      var group = input.closest(GROUP);
      if (group) applySearch(group, '');
    }
  });

  function init() { scan(document.body); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Re-init when facets HTML is replaced/re-rendered or moved
  if (window.MutationObserver) {
    var pending = [];
    var scheduled = false;
    var mo = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) if (added[j].nodeType === 1) pending.push(added[j]);
      }
      if (pending.length && !scheduled) {
        scheduled = true;
        (window.requestAnimationFrame || setTimeout)(function () {
          scheduled = false;
          var nodes = pending; pending = [];
          for (var k = 0; k < nodes.length; k++) scan(nodes[k]);
        });
      }
    });
    var start = function () { mo.observe(document.body, { childList: true, subtree: true }); };
    if (document.body) start(); else document.addEventListener('DOMContentLoaded', start);
  }
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
